export const Representor = {
  Bode: 'bode',
  Agent: 'agent',
};

export const CalculationType = {
  Buyer: 'buyer',
  Seller: 'seller',
};

export const ImageSize = {
  Large: 840,
  Small: 600,
};

export default {
  Representor,
  CalculationType,
  ImageSize,
};
